import React from "react";
import PropTypes from "prop-types";
import axios from 'axios';
import reactT from '../../components/reactT';

class Bookmark extends React.Component {
  constructor(props) {
    super(props);
    let isFlagged = this.props.flagged;
    this.state = {
      flagged: isFlagged,
      title : isFlagged === true ? reactT('Remove this document from your bookmarks.') : reactT('Add this document to your bookmarks.'),
      action: isFlagged === true ? 'unflag' : 'flag',
      linktext: isFlagged === true ? reactT('Unbookmark') : reactT('Bookmark'),
      token: isFlagged === true ? this.props.unflagToken : this.props.flagToken,
    };
    this.onChange = this.onChange.bind(this);
  }

  
  onChange = (e) => {
  e.preventDefault();
  const throbberWrapper = document.createElement("div");
  throbberWrapper.className = "ajax-progress ajax-progress-throbber";
  const throbberElement = document.createElement("div");
  throbberElement.className = "throbber";
  throbberWrapper.appendChild(throbberElement);
  const throbber = throbberWrapper;
  const parent = e.target.parentElement;
  parent.appendChild(throbber);
  const actionDone = document.createElement("p");
  actionDone.className = "js-flag-message";

  if(parent.querySelector('.js-flag-message'))
  parent.querySelector('.js-flag-message').remove();

  axios.post(e.target.href).then(resp => {
      if(resp.status === 200){
        parent.removeChild(throbber);
        this.setState(previousState => ({
          flagged: !previousState.flagged,
          title: !previousState.flagged  === true ? reactT('Remove this document from your bookmarks.') : reactT('Add this document to your bookmarks.'),
          action: !previousState.flagged === true ? 'unflag' : 'flag',
          linktext: !previousState.flagged === true ? reactT('Unbookmark') : reactT('Bookmark'),
          token: !previousState.flagged === true ? this.props.unflagToken : this.props.flagToken,
       }));
       actionDone.innerText = resp.data[1].message;
       parent.appendChild(actionDone);
       actionDone.addEventListener('animationend', function (event) {
         return event.target.remove();
       }, false);
      }
  })
  };

  render() {
    const langcode = document.querySelector('html').getAttribute('lang');
    return (
      <>
      <div className={'flag flag-favorite js-flag-favorite-'+this.props.docID+' action-'+this.state.action}>
      <a title={this.state.title} href={(langcode === 'en' ? '' : '/' + langcode) + '/flag/'+this.state.action+'/favorite/'+this.props.docID+'?token='+this.state.token} rel="nofollow" dangerouslySetInnerHTML={{__html: this.state.linktext}}
      onClick={this.onChange}
      />
    </div>
    </>
    );
  }
}

Bookmark.propTypes = {
  docID: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  flagged: PropTypes.bool,
  title: PropTypes.string,
};

export default Bookmark;
